<template>
    <!-- 첨부파일 미리보기 영역 -->
    <div class="previewFileImg" v-if="isPreview">
      <div class="previewTop text-center">
        <button class="btn btn-secondary btn-sm onmaum-w-90" @click="isPreview = false; previewFile = '';">닫기</button>
      </div>
      <div class="previewBottom">
        <img class="previewImg" :src="previewFile"/>
      </div>
    </div>
  
    <!-- 고객정보 관리 영역 -->
    <div class="black-bg-2" v-if="isCustomerManage">
      <div class="white-bg-2">
        <main>
          <div class="py-4 container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card editArea">
                  <div class="card-header pb-0">
                    <div class="row">
                      <div class="col-md-3">
                        <button class="btn btn-outline-danger btn-sm ms-auto w-100" v-if="isModify && this.$store.state.login.userType == '관리자'" @click="deleteCustomerInfo()">삭제</button>
                      </div>
                      <div class="col-md-2">
                        
                      </div>
                      <div class="col-md-1 onmaum-text-right">
                        <i class="far fa-star onmaum-font-2rem onmaum-text-alarm onmaum-text-cursor" v-if="!isFavorite" @click="setFavor();"></i><!-- 미선택 -->
                        <i class="fas fa-star onmaum-font-2rem onmaum-text-alarm onmaum-text-cursor" v-if="isFavorite" @click="setFavor();"></i><!-- 선택 -->
                      </div>
                      <div class="col-md-3">
                        <button class="btn btn-outline-secondary btn-sm ms-auto w-100" @click="insertMode">취소</button>
                      </div>
                      <div class="col-md-3">
                        <button class="btn btn-warning btn-sm ms-3 w-100" v-if="isModify && (this.$store.state.login.userType == '관리자' || this.$store.state.login.userType == '플래너')" @click="modifyCustomerInfo">저장</button>
                        <button class="btn btn-success btn-sm ms-auto w-100" v-if="!isModify && (this.$store.state.login.userType == '관리자' || this.$store.state.login.userType == '플래너')" @click="insertCustomerInfo">추가</button>
                      </div>
                      <!-- <argon-button color="success" size="sm" class="ms-auto" >저장</argon-button> -->
                    </div>
                  </div>
                  <div class="card-body onmaum-overflow-y onmaum-overflow-type02 onmaum-h-75-v">
                    <div class="contractArea">
                      <div class="row" v-for="(_, i) in customerContract" :key="i">
                        <div class="col-md-2 mb-2">
                          <label class="form-control-label fs-5">체결여부{{ i + 1 }}</label>
                          <div class=text-center>
                            <div class="form-check form-switch d-inline-block ">
                              <input class="form-check-input" type="checkbox" role="switch" :id="`contractFlag${i}`" v-model="customerContract[i].flag">
                              <label class="form-check-label" :for="`contractFlag${i}`">
                                <span class="badge bg-danger" v-if="!customerContract[i].flag">미체결</span>
                                <span class="badge bg-primary" v-if="customerContract[i].flag">체결</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 mb-2">
                          <label class="form-control-label fs-5">체결일{{ i + 1 }}</label>
                          <VueDatePicker v-model="customerContract[i].date" locale="kr" cancelText="취소" selectText="선택" :format="formatContract(i)" placeholder="체결일"></VueDatePicker>
                        </div>
                        <div class="col-md-3 mb-2">
                          <label for="contractPrice" class="form-control-label fs-5">보험료{{ i + 1 }}</label>
                          <input id="contractPrice" class="form-control invalid" type="text" v-model="customerContract[i].price" placeholder="보험료"/>
                        </div>
                        <div class="col-md-3 mb-2">
                          <label for="contractCompany" class="form-control-label fs-5">보험사{{ i + 1 }}</label>
                          <input id="contractCompany" class="form-control invalid" type="text" v-model="customerContract[i].company" placeholder="보험사"/>
                        </div>
                        <div class="col-md-1 mb-2">
                          <label class="form-control-label fs-5">삭제버튼</label>
                          <button class="btn btn-outline-danger w-100" @click="deleteContract(i)" :disabled="customerContract.length <= 1">삭제</button>
                        </div>
                        <hr>
                      </div>
                      <div class="row">
                        <div class="col-md-12 text-center onmaum-text-default-hover" @click="addContract(i)">
                            <i class="far fa-plus-square fs-3"></i>
                        </div>
                      </div>
                    </div>
                    
                    <div class="paymentArea">
                      <div v-for="(payments, j) in customerPayment" :key="j">
                        <label for="customerPayment" class="form-control-label fs-5">납입정보 {{ j + 1 }}</label><label class="fw-500" style="font-size: 1rem;">{{ `(${petInfo[j].petName}/${petInfo[j].petBreed}/${petInfo[j].petRegNum})` }}</label>
                        <div class="row text-center">
                          <div class="col-2 mb-2" v-for="(payment, i) in payments" :key="i">
                            
                            <div class="card m-auto onmaum-w-80 onmaum-shadow-default" @click="setPayment(j, i, payment)">
                              <div class="card-header p-0 pt-2 border-bottom" style="font-weight: 600;" :style="payment?`background: #A56F05AD; color: white;`:''">
                                {{(i + 1).toString().padStart(2, '0') + '회차' }}
                              </div>
                              <div class="card-body p-0">
                                <p class="m-0" v-if="payment"><i class="fas fa-paw" :style="`color: #A56F05;`"></i></p>
                                <p class="m-0 text-sm" v-if="payment">{{ payment }}</p>
                                <p class="m-0" v-if="!payment"><i class="fas fa-times"></i></p>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
  
  
                    <p class="text-uppercase text-md fw-bold">필수 정보</p>
                    <div class="row">
                      <div class="col-md-2 mb-2">
                        <label for="customerName" class="form-control-label fs-5">이름</label>
                        <input id="customerName" class="form-control invalid" type="text" v-model="customerName" placeholder="계약자 이름"/>
                      </div>
                      <div class="col-md-4 mb-2">
                        <label for="customerRegistNumber01" class="form-control-label fs-5">주민등록번호</label>
                        <div>
                            <input id="customerRegistNumber01" class="form-control invalid w-45 float-start" type="text" v-model="customerRegistNumber01" placeholder="생년월일(yymmdd)" />
                            <div class="w-10 float-start text-center">-</div>
                            <input class="customerRegistNumber02 form-control invalid w-45 float-end" type="text" v-model="customerRegistNumber02" placeholder="주민등록번호 뒷자리(7자리)" />
                        </div>
                      </div>
                      <div class="col-md-6 mb-2">
                        <label for="customerPhone" class="form-control-label fs-5">휴대전화</label>
                        <div class="row">
                          <div class="col-md-3">
                            <select id="customerPlanner" class="form-select" v-model="customerTelecom">
                              <option value="0">통신사 선택</option>
                              <option value="SKT">SKT</option>
                              <option value="KT">KT</option>
                              <option value="LGU+">LGU+</option>
                              <option value=">SKT 알뜰폰">SKT 알뜰폰</option>
                              <option value="KT 알뜰폰">KT 알뜰폰</option>
                              <option value="LGU+ 알뜰폰">LGU+ 알뜰폰</option>
                            </select>
                          </div>
                          <div class="col-md-9">
                            <input id="customerPhone" class="form-control invalid" type="text" v-model="customerPhone" placeholder="휴대전화(숫자만)" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-8 mb-2">
                        <label for="customerAddress" class="form-control-label fs-5">주소</label>
                        <div class="row">
                            <div class="col-md-1">
                                <input class="form-control invalid float-start" type="text" v-model="postalCode" placeholder="우편번호" disabled>
                            </div>
                            <div class="col-md-2">
                                <button class="btn btn-dark w-100" @click="execDaumPostcode()">우편번호찾기</button>
                            </div>
                            <div class="col-md-3">
                                <input class="form-control invalid" type="text" v-model="address" placeholder="기본주소" disabled  >
                            </div>
                            <div class="col-md-3">
                                <input class="form-control invalid" type="text" v-model="extraAddress" placeholder="참고항목" disabled>
                            </div>
                            <div class="col-md-3">
                                <input id="customerAddress" class="form-control invalid" type="text" v-model="detailAddress" placeholder="상세주소">
                            </div>
                        </div>
                      </div>
                      <div class="col-md-2 mb-2">
                        <label for="customerJob" class="form-control-label fs-5">직업</label>
                        <input id="customerJob" class="form-control invalid" type="text" v-model="customerJob" placeholder="직업"/>
                      </div>
                      
                      <div class="col-md-2 mb-2">
                        <label for="customerPlanner01" class="form-control-label fs-5">담당 플래너</label>
                        <select id="customerPlanner01" class="form-select" v-model="customerPlanner01">
                          <option :value="{'planner_id': 0, 'planner_name': ''}" selected="selected">플래너 선택</option>
                          <option v-for="(planner, i) in plannerInfo" :key="i" :value="{'planner_id': planner._id, 'planner_name': planner.name}">{{ planner.name }}</option>
                        </select>
                      </div>

                      <hr class="horizontal dark" />

                      <p class="text-uppercase text-md fw-bold">반려동물 정보</p>
                      <div class="col-md-12 mb-3">

                        <!-- 반려동물 정보 타이틀 -->
                        <div class="row">
                          <div class="col-md-2 mb-2">
                            <label for="petKind" class="form-control-label fs-5">반려동물 구분</label>
                          </div>
                          <div class="col-md-2 mb-2">
                            <label for="petBreed" class="form-control-label fs-5">품종</label>
                          </div>
                          <div class="col-md-2 mb-2">
                            <label for="petName" class="form-control-label fs-5">이름</label>
                          </div>
                          <div class="col-md-1 mb-2">
                            <label for="petAge" class="form-control-label fs-5">나이</label>
                          </div>
                          <div class="col-md-2 mb-2">
                            <label for="petRegNum" class="form-control-label fs-5">동물등록번호</label>
                          </div>
                          <div class="col-md-1 mb-2">
                            <label class="form-control-label fs-5">입양여부</label>
                          </div>
                          <div class="col-md-1 mb-2">
                            <label class="form-control-label fs-5">중성화여부</label>
                          </div>
                          <div class="col-md-1 mb-2">
                            
                          </div>
                        </div>
                        
                        <!-- 반려동물 정보 -->
                        <div class="row" v-for="(pet, i) in petInfo" :key="i">
                          <div class="col-md-2 mb-2">
                            <select id="petKind" class="form-select invalid" v-model="pet.petKind">
                              <option selected="selected" value="">선택하세요</option>
                              <option value="개">개</option>
                              <option value="고양이">고양이</option>
                            </select>
                          </div>
                          <div class="col-md-2 mb-2">
                            <input id="petBreed" class="form-control invalid" v-model="pet.petBreed" placeholder="(ex)말티즈,코솟.."/>
                          </div>
                          <div class="col-md-2 mb-2">
                            <input id="petName" class="form-control invalid" v-model="pet.petName" placeholder="반려동물 이름"/>
                          </div>
                          <div class="col-md-1 mb-2">
                            <input id="petAge" class="form-control invalid" v-model="pet.petAge" placeholder="반려동물 나이"/>
                          </div>
                          <div class="col-md-2 mb-2">
                            <input id="petRegNum" class="form-control invalid" v-model="pet.petRegNum" placeholder="동물등록번호"/>
                          </div>
                          <div class="col-md-1 mb-2 my-auto">
                            <div class=text-center>
                              <div class="form-check form-switch d-inline-block ">
                                <input class="form-check-input" type="checkbox" role="switch" id="petAdopt" v-model="pet.petAdopt" :style="pet.petAdopt?`background-color:#2dce89; border-color: #2dce89;`:''">
                                <label class="form-check-label" for="petAdopt">
                                  <span class="badge bg-success" v-if="pet.petAdopt">입양</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-1 mb-2 my-auto">
                            <div class=text-center>
                              <div class="form-check form-switch d-inline-block ">
                                <input class="form-check-input" type="checkbox" role="switch" id="petNeutral" v-model="pet.petNeutral">
                                <label class="form-check-label" for="petNeutral">
                                  <span class="badge bg-primary" v-if="pet.petNeutral">중성화</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <button class="col-md-1 btn btn-outline-danger p-1 my-auto" @click="deletePet(i)">
                            삭제
                          </button>
                        </div>
                        
                        <div class="text-center mt-3">
                          <button class="btn btn-outline-pet btn-sm ms-auto" @click="addPet">반려동물 추가</button>
                        </div>
                      </div>
                      
                      <hr class="horizontal dark" />

                      <label class="form-control-label fs-5">기타 정보</label>
                      <div class="col-md-12 mb-3 memoArea">
                        <div class="row mb-3" v-for="(_, i) in customerMemo" :key="i">
                          <div class="col-md-1 text-center text-sm font-weight-bolder opacity-8 my-auto">
                            메모 {{ i + 1 }}
                          </div>
                          <div class="col-md-2">
                            <VueDatePicker v-model="customerMemoDate[i]" ref="vdMemoDate" locale="kr" cancelText="취소" selectText="선택" :format="formatMemoDate(i)" :placeholder="'날짜' + (i + 1)"></VueDatePicker>
                          </div>
                          <div class="col-md-8">
                            <input class="customerMemo form-control invalid" type="text" v-model="customerMemo[i]" :placeholder="'메모' + (i + 1)">
                          </div>
                          <button class="col-md-1 btn btn-outline-danger p-1 my-auto" @click="deleteMemo(i)">
                            삭제
                          </button>
                        </div>
                        
                        <div class="text-center">
                          <button class="btn btn-outline-primary btn-sm ms-auto" @click="addMemo">메모 추가</button>
                        </div>
  
                      </div>
  
                      <label class="form-control-label fs-5">첨부파일</label>
                      <div class="row">
                        <!-- 파일 추가 버튼 영영 -->
                        <div class="col-12 mb-2">
                          <div class="filebox">
                            <label for="attachFile">파일추가</label>
                            <input type="file" id="attachFile" multiple="true" @change="attachFileChanged"> 
                          </div>
                        </div>
  
                        <!-- 첨부된 파일 영역 -->
                        <div class="col-md-4 col-12 mb-1" v-for="(file, i) in newAttachFile" :key="i">
                          <div class="card">
                            <div class="card-header">
                              <p class="onmaum-text-ellipsis">{{ file.name }}</p>
                              <div class="row">
                                <div class="col-6">
                                  <button class="btn btn-info btn-sm w-100" @click="preview(i)">보기</button>
                                </div>
                                <div class="col-6">
                                  <button class="btn btn-danger btn-sm w-100" @click="deleteFile(i)">삭제</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
  
                        <!-- 기존 등록된 파일 영역 -->
                        <div class="col-md-4 col-12 mb-1" v-for="(file, i) in curAttachFile" :key="i">
                          <div class="card">
                            <div class="card-header">
                              <p class="onmaum-text-ellipsis">{{ decodeURIComponent(file.originalname) }}</p>
                              <div class="row">
                                <div class="col-6">
                                  <button class="btn btn-onmaum btn-sm w-100" @click="download(file.key)">다운로드</button>
                                </div>
                                <div class="col-6">
                                  <button class="btn btn-danger btn-sm w-100" @click="deleteFile2(i)">삭제</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- End 기존 등록된 파일 영역 -->
                      </div>
                      <!-- End 첨부파일 영역 -->
                    </div>
                    <!-- End 필수정보 -->
                  </div>
                  <!-- End 고객 정보 수정 영역 -->
  
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  
  
    
  </template>
  
  <script>
  import VueDatePicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css';
  import $ from 'jquery';
  
  export default {
      name: 'PetCustomerManage',
      props:{
        isCustomerManage: Boolean,
        customerID: Number,
        manageMode: String,
        toggleManage: Function,
      },
      components: { 
        VueDatePicker 
      },
      data() {
          return {
            customerContract: [{flag: false, date: '', price: '', company: ''}],
            customerPayment: [['']],
  
            isFavorite: false,
  
            customerName: '',
            customerRegistNumber01: '',
            customerRegistNumber02: '',
            customerTelecom: '0',
            customerPhone: '',
            
            postalCode: '',
            address: '',
            detailAddress: '',
            extraAddress: '',

            customerJob: '',
            
            petInfo: [{petKind: '', petBreed: '', petName: '', petAge: '', petAdopt: false, petNeutral: false, petRegNum: ''}],
            petKind: '',
            petBreed: '',
            petName: '',
            petAge: '',
            petAdopt: false,
            petNeutral: false,
            petRegNum: '',
            
            customerPlanner01: {planner_id: 0, planner_name: ''},
            customerPlanner02: {planner_id: 0, planner_name: ''},
  
            customerMemoDate: [''],
            customerMemo: [''],
  
            newAttachFile: [], //이번에 새로 추가하는 파일들
            curAttachFile: [], //현재 DB에 존재하는 파일들
            isPreview: false, //미리보기 상태
            previewFile: '', //미리보기 이미지 정보
  
            isModify: false,
            modifyID: 0,
  
            isUpdated: false,
          }
      },
      watch: {
        //보험료
        customerContract: {
          handler(a) {
            for(let i = 0; i < a.length; i++){
              let temp = a[i].price.replaceAll(',', '');
  
              if (/\D/g.test(temp)){
                this.$store.commit('setAlert', {
                                                'alertStatus': 'notice'
                                                ,'alertTitle': '고객 관리'
                                                ,'alertContent': `숫자만 입력하세요`
                                            });
                temp = temp.substring(0, temp.length - 1);
              }
  
              temp = Number(temp);
  
              temp = temp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
              this.customerContract[i].price = temp;
  
            }
          },
          deep: true
        },
        //생년월일 체크
        customerRegistNumber01(a){
          if (/\D/g.test(a)){
            this.$store.commit('setAlert', {
                                            'alertStatus': 'notice'
                                            ,'alertTitle': '고객 관리'
                                            ,'alertContent': `숫자만 입력하세요`
                                        });
            this.customerRegistNumber01 = a.substring(0, a.length - 1);
          }
          if(a.length >= 6){
            $('.customerRegistNumber02').focus();
          }
        },
        //주민번호 뒷자리 체크
        customerRegistNumber02(a){
          if (/\D/g.test(a)){
            this.$store.commit('setAlert', {
                                            'alertStatus': 'notice'
                                            ,'alertTitle': '고객 관리'
                                            ,'alertContent': `숫자만 입력하세요`
                                        });
            this.customerRegistNumber02 = '';
          }
          if(a.length >= 7){
            document.getElementById('customerPhone').focus();
          }
        },
        //휴대전화 체크
        customerPhone(a){
          let temp = a.replaceAll('-', '');
  
          if (/\D/g.test(temp)){
            this.$store.commit('setAlert', {
                                            'alertStatus': 'notice'
                                            ,'alertTitle': '고객 관리'
                                            ,'alertContent': `숫자만 입력하세요`
                                        });
            temp = temp.substring(0, temp.length - 1);
          }
  
          if(temp.length == 11){
            this.customerPhone = temp.toString().replace(/^(\d{3})(\d{4})(\d{4})$/, '$1-$2-$3');
          }else if(temp.length == 10 && temp.substring(0, 2) == '02'){
            this.customerPhone = temp.toString().replace(/^(\d{2})(\d{4})(\d{4})$/, '$1-$2-$3');
          }else if(temp.length == 10 && temp.substring(0, 2) != '02'){
            this.customerPhone = temp.toString().replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3');
          }else{
            this.customerPhone = temp.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '-');
          }
  
        },
      },
      computed: {
          plannerInfo(){
            return this.$store.state.planner.plannerInfo;
          },
      },
  
      methods: {
        //우편번호, 주소 검색
        execDaumPostcode() {
            new window.daum.Postcode({
                oncomplete: (data) => {
                  if (this.extraAddress !== "") {
                      this.extraAddress = "";
                  }
                  if (data.userSelectedType === "R") {
                      // 사용자가 도로명 주소를 선택했을 경우
                      this.address = data.roadAddress;
                  } else {
                      // 사용자가 지번 주소를 선택했을 경우(J)
                      this.address = data.jibunAddress;
                  }
          
                  // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
                  if (data.userSelectedType === "R") {
                      // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                      // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                      if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
                      this.extraAddress += data.bname;
                      }
                      // 건물명이 있고, 공동주택일 경우 추가한다.
                      if (data.buildingName !== "" && data.apartment === "Y") {
                      this.extraAddress +=
                          this.extraAddress !== ""
                          ? `, ${data.buildingName}`
                          : data.buildingName;
                      }
                      // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                      if (this.extraAddress !== "") {
                      this.extraAddress = `(${this.extraAddress})`;
                      }
                  } else {
                      this.extraAddress = "";
                  }
                  // 우편번호를 입력한다.
                  this.postalCode = data.zonecode;
                },
            }).open();
        },

        //계약일 포맷
        formatContract(id){
          const date = this.customerContract[id].date?new Date(this.customerContract[id].date):new Date();
          const day = date.getDate();
          const month = date.getMonth() + 1;
          const year = date.getFullYear();
  
          return `${year}/${month}/${day}`;
        },

        //반려동물 추가
        addPet(){
          this.petInfo.push({petKind: '', petBreed: '', petName: '', petAge: '', petAdopt: false, petNeutral: false, petRegNum: ''});
          this.customerPayment.push(['']);
        },

        //반려동물 삭제
        deletePet(id) {
          if(confirm(`반려동물의 납입정보도 함께 삭제됩니다. 삭제하시겠습니까?`)){
            this.petInfo.splice(id, 1);
            this.customerPayment.splice(id, 1);
          }
        },
  
        //메모일 포맷
        formatMemoDate(id){
          id = Number(id);
          const date = this.customerMemoDate[id]?new Date(this.customerMemoDate[id]):new Date();
          const day = date.getDate();
          const month = date.getMonth() + 1;
          const year = date.getFullYear();
  
          return `${year}/${month}/${day}`;
        },
  
        //메모 추가
        addMemo(){
          this.customerMemo = this.customerMemo.filter(a => {if(a != '') return a;});
          this.customerMemo.push('');
          this.customerMemoDate.push('');
        },
  
        //메모 삭제
        deleteMemo(id){
          this.customerMemo.splice(id, 1);
          this.customerMemoDate.splice(id, 1);
        },
  
        //체결정보 추가
        addContract(){
          this.customerContract = this.customerContract.filter(a => a.date != '' || (a.price != '' && a.price != 0) || a.company != '');
          this.customerContract.push({flag: false, date: '', price: '', company: ''});
        },
  
        //체결정보 삭제
        deleteContract(id){
          this.customerContract.splice(id, 1);
        },

        //납입정보 등록
        setPayment(j, i, payment){
          if(payment && this.$store.state.login.userType == '관리자'){
            if(confirm(`[(${+i + 1}회차)] 납입여부를 취소하시겠습니까?${'\n'}취소 시 현재 날짜 이전으로 납입일을 설정할 수 없습니다.`)){
              this.customerPayment[j][i] = '';
              for(let idx = this.customerPayment[j].length - 1; idx > 0; idx--){
                if(this.customerPayment[j][idx] == '' && this.customerPayment[j][idx - 1] == ''){
                  this.customerPayment[j].splice(idx, 1);
                }else{
                  break;
                }
              }
            }
          }else{
            this.customerPayment[j][i] = new Date().toLocaleString();
            if(this.customerPayment[j].length - 1 == i){
              this.customerPayment[j].push('');
            }
          }
        },
  
        //첨부파일 변경 시
        attachFileChanged(){
          let fileUploader = $('#attachFile').get(0);
          let files = [...fileUploader.files];
  
          for(let i = 0; i < files.length; i++){
            files[i].src = URL.createObjectURL(files[i]);
            this.newAttachFile.push(files[i]);
          }
  
          //빈 값 제거
          this.newAttachFile = this.newAttachFile.filter(a => {if(a != '') return a;});
        },
  
        //첨부파일 미리보기
        preview(i){
          this.isPreview = true;
          this.previewFile = this.newAttachFile[i].src;
        },
  
        //첨부파일 삭제
        deleteFile(i){
          this.newAttachFile.splice(i, 1);
        },
  
        //기 등록된 첨부파일 삭제
        deleteFile2(i){
          this.curAttachFile.splice(i, 1);
        },
  
        //첨부파일 다운로드
        download(key){
          this.$store.dispatch('downloadFile', `${key}`);
        },
  
        //즐겨찾기 여부 변경
        setFavor(){
          this.isFavorite = !this.isFavorite;
        },
  
        //편집 모드
        modifyMode(id){
          //$('.class-' + this.modifyID).attr('class', 'list-group-item border-0 p-4 mb-2 mb-3 bg-gray-100 border-radius-lg class-' + this.modifyID);
          $('.editArea').attr('class', 'card editArea');
  
          this.modifyID = id;
          let tempInfo = this.$store.state.customer.pCustomerInfoOrigin.find(a => a._id == id);
  
          //데이터 바인딩
          this.customerContract = tempInfo.contract;
          this.customerPayment = tempInfo.payment??[['']];
  
          this.isFavorite = tempInfo.isFavorite;
  
          this.customerName = tempInfo.name;
          this.customerRegistNumber01 = tempInfo.decrypt_regist_number.substr(0, 6);
          this.customerRegistNumber02 = tempInfo.decrypt_regist_number.substr(6, 7);
          this.customerTelecom = tempInfo.phone.telecom;
          this.customerPhone = tempInfo.phone.phone;
          
          this.postalCode = tempInfo.address.postal_code;
          this.address = tempInfo.address.address;
          this.detailAddress = tempInfo.address.detail_address;
          this.extraAddress = tempInfo.address.extra_address;
          
          this.customerJob = tempInfo.job;

          this.petInfo = tempInfo.petInfo??[{petKind: '', petBreed: '', petName: '', petAge: '', petAdopt: false, petNeutral: false, petRegNum: ''}];
          // this.petKind = tempInfo.petKind??'';
          // this.petBreed = tempInfo.petBreed??'';
          // this.petName = tempInfo.petName??'';
          // this.petAge = tempInfo.petAge??'';
          // this.petAdopt = tempInfo.petAdopt;
          // this.petNeutral = tempInfo.petNeutral;
          // this.petRegNum = tempInfo.petRegNum;

          this.customerPlanner01 = tempInfo.planner.planner01;
          this.customerPlanner02 = tempInfo.planner.planner02;
  
          this.customerMemo = tempInfo.memo;
          this.customerMemoDate = tempInfo.memoDate;
  
          this.newAttachFile = [],
          this.curAttachFile = tempInfo.attach_file;
  
          //왼쪽 정보 편집 창 상태 변경(버튼, border color 등 편집 상태임을 확인할 수 있도록)
          this.isModify = true;
          tempInfo = '';
          //$('.class-' + this.modifyID).attr('class', 'list-group-item border-danger border-top p-4 mb-2 mb-3 bg-gray-100 border-radius-lg class-' + this.modifyID);
          $('.editArea').attr('class', 'card editArea border border-danger');
        },
  
        //입력 모드
        insertMode(){
          this.isModify = false;
  
          this.customerContract = [{flag: false, date: '', price: '', company: ''}];
          this.customerPayment = [['']];
  
          this.isFavorite = false;
  
          this.customerName = '';
          this.customerRegistNumber01 = '';
          this.customerRegistNumber02 = '';
          this.customerTelecom = '0';
          this.customerPhone = '';
          
          this.postalCode = '';
          this.address = '';
          this.detailAddress = '';
          this.extraAddress = '';

          this.customerJob = '';

          this.petInfo = [{petKind: '', petBreed: '', petName: '', petAge: '', petAdopt: false, petNeutral: false, petRegNum: ''}];
          this.petKind = '';
          this.petBreed = '';
          this.petName = '';
          this.petAge = '';
          this.petAdopt = false;
          this.petNeutral = false;
          this.petRegNum = '';
  
          this.customerPlanner01 = {planner_id: 0, planner_name: ''};
          this.customerPlanner02 = {planner_id: 0, planner_name: ''};
  
          this.customerMemo = [''];
          this.customerMemoDate = [''];
  
          this.newAttachFile = [],
          this.curAttachFile = [],
  
          $('.class-' + this.modifyID).attr('class', 'list-group-item border-0 p-4 mb-2 mb-3 bg-gray-100 border-radius-lg class-' + this.modifyID);
          $('.editArea').attr('class', 'card editArea');
          this.modifyID = 0;
  
          this.toggleManage();
        },
  
        //편집 저장
        modifyCustomerInfo(){
          this.$store.dispatch('modifyCustomerInfo', { _id: this.modifyID
                                                      ,isFavorite: this.isFavorite
                                                      ,name: this.customerName
                                                      ,regist_number: this.customerRegistNumber01 + this.customerRegistNumber02
                                                      ,phone: {
                                                                telecom: this.customerTelecom
                                                                ,phone: this.customerPhone
                                                              }
                                                      ,address: {
                                                                postal_code: this.postalCode
                                                                ,address: this.address
                                                                ,extra_address: this.extraAddress
                                                                ,detail_address: this.detailAddress
                                                              }
                                                      ,job: this.customerJob
                                                      ,petInfo: this.petInfo
                                                      // ,petKind: this.petKind
                                                      // ,petBreed: this.petBreed
                                                      // ,petName: this.petName
                                                      // ,petAge: this.petAge
                                                      // ,petAdopt: this.petAdopt
                                                      // ,petNeutral: this.petNeutral
                                                      // ,petRegNum: this.petRegNum
                                                      ,planner: {
                                                                planner01: this.customerPlanner01
                                                                ,planner02: this.customerPlanner02
                                                              }
                                                      ,memo: this.customerMemo.filter(a => {if(a != '') return a;}).length ? this.customerMemo.filter(a => {if(a != '') return a;}) : ['']
                                                      ,memoDate: this.customerMemoDate.filter((a, b) => this.customerMemo[b] != '').length
                                                                  ?this.customerMemoDate.filter((a, b) => this.customerMemo[b] != '').map((a) => {return a?new Date(a).toLocaleDateString():''}) 
                                                                  :['']
                                                      ,attach_file: this.newAttachFile
                                                      ,cur_attach_file: this.curAttachFile
                                                      ,contract: this.customerContract.filter(a => a.date != '' || (a.price != '' && a.price != 0) || a.company != '').length 
                                                                 ?this.customerContract.filter(a => a.date != '' || (a.price != '' && a.price != 0) || a.company != '').map((a) => {return {...a, price: a.price.replace(',', ''), date: a.date?new Date(a.date).toLocaleDateString():''}})
                                                                 :[{flag: false, date: '', price: '', company: ''}]
                                                      ,payment: this.customerPayment
                                                      ,update_date: new Date().toLocaleString()
                                                      ,update_id: this.$store.state.login.loginID
                                                    });
          this.insertMode();
        },
  
        //입력 저장
        insertCustomerInfo(){
          this.$store.dispatch('insertCustomerInfo', { isFavorite: this.isFavorite
                                                      ,name: this.customerName
                                                      ,regist_number: this.customerRegistNumber01 + this.customerRegistNumber02
                                                      ,phone: {
                                                                telecom: this.customerTelecom
                                                                ,phone: this.customerPhone
                                                              }
                                                      ,address: {
                                                                postal_code: this.postalCode
                                                                ,address: this.address
                                                                ,extra_address: this.extraAddress
                                                                ,detail_address: this.detailAddress
                                                              }
                                                      ,job: this.customerJob
                                                      ,petInfo: this.petInfo
                                                      // ,petKind: this.petKind
                                                      // ,petBreed: this.petBreed
                                                      // ,petName: this.petName
                                                      // ,petAge: this.petAge
                                                      // ,petAdopt: this.petAdopt
                                                      // ,petNeutral: this.petNeutral
                                                      // ,petRegNum: this.petRegNum
                                                      ,planner: {
                                                                planner01: this.customerPlanner01
                                                                ,planner02: this.customerPlanner02
                                                              }
                                                      ,memo: this.customerMemo.filter(a => {if(a != '') return a;}).length ? this.customerMemo.filter(a => {if(a != '') return a;}) : ['']
                                                      ,memoDate: this.customerMemoDate.filter((a, b) => this.customerMemo[b] != '').length
                                                                  ?this.customerMemoDate.filter((a, b) => this.customerMemo[b] != '').map((a) => {return a?new Date(a).toLocaleDateString():''})
                                                                  :['']
                                                      ,attach_file: this.newAttachFile
                                                      ,contract: this.customerContract.filter(a => a.date != '' || (a.price != '' && a.price != 0) || a.company != '').length 
                                                                 ?this.customerContract.filter(a => a.date != '' || (a.price != '' && a.price != 0) || a.company != '').map((a) => {return {...a, price: a.price.replace(',', ''), date: a.date?new Date(a.date).toLocaleDateString():''}})
                                                                 :[{flag: false, date: '', price: '', company: ''}]
                                                      ,payment: this.customerPayment
                                                      ,insert_date: new Date().toLocaleString()
                                                      ,insert_id: this.$store.state.login.loginID
                                                    });
          this.insertMode();
        },
  
        //삭제
        deleteCustomerInfo(){
          this.$store.commit('setAlert', {
                                            'alertStatus': 'confirm'
                                            ,'alertTitle': '고객 관리'
                                            ,'alertContent': `선택한 고객 정보를 삭제하시겠습니까?|1. 고객명: ${this.customerName}|2. 반려동물 정보(품종/나이): ${this.petKind}/${this.petAge}| |**삭제한 정보는 복구할 수 없으므로 신중히 삭제하시기 바랍니다.}`
                                            ,'callback': 'deleteCustomerInfo'
                                            ,'parameter': {id: this.modifyID}
                                        }
                            );
          this.insertMode();
        },
        
      },
  
      mounted() {
          //관리자 및 플래너만 이 페이지에 접근 가능
          if(this.$store.state.login.userType == '기타사용자'){
            this.$router.push('/');
          }
  
          //플래너 정보 가져오기
          this.$store.dispatch('getPlannerInfo');
  
          //플래너의 경우, 플래너 선택 영역을 기본적으로 본인으로 선택
          if(this.$store.state.login.userType == '플래너'){
            let obj = this.plannerInfo.filter((a) => a.name == this.$store.state.login.userName)[0];
            this.customerPlanner01 = {planner_id: obj._id, planner_name: obj.name};
          }
      },
  
      updated(){
        if(this.manageMode == 'select' && !this.isUpdated){
          this.modifyMode(this.customerID);
          this.isUpdated = !this.isUpdated;
        }
      },
  
  }
  </script>
  
  <style>
  .previewFileImg{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
  }
  
  .previewTop{
    width: 100%;
    height: 10%;
    margin: 10px 0 10px 0;
  }
  
  .previewBottom{
    width: 100%;
    height: 90%;
    display: flex;
    justify-content: center;
  }
  
  .previewImg{
    width: auto;
    height: 90%;
  }
  
  .black-bg-2 {
    width: 100%; height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    /* padding: 20px; */
    z-index: 9999;
  
    justify-content: center;
    align-items: center;
    display: flex;
  }
  
  .white-bg-2 {
    background: white;
    /* width: 75%;
    height: 90%; */
    width: 100%;
    height: 100%;
    min-height: 50%;
    position: relative;
    margin: auto;
    /* padding: 20px; */
    border-radius: 8px;
  }
  
  .contractArea {
    background: rgba(255, 0, 0, 0.1);
    border-radius: 15px;
    padding: 10px;
    margin-bottom: 10px;
  }

  .paymentArea {
    background: #A56F0510;
    border-radius: 15px;
    padding: 10px;
    margin-bottom: 10px;
  }
  
  /* -ms-touch-action: pinch-zoom;
    touch-action: pinch-zoom; */
    
  /* 
  .infoArea {
    overflow-x: hidden;
    overflow-y: scroll;
    height: 65vh;
  }
  
  .infoArea::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #FF931E;
  }
  
  .infoArea::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #FFBA70;
  }
  
  .infoArea::-webkit-scrollbar-button {
    width: 0;
    height: 0;
  } */
  
  </style>